module.exports = __webpack_public_path__ + "static/media/cq_indietro.c56686d2.svg";